import Api from './api.service'

export default {
  create (object) {
    return Api().post('link/create', object)
  },
  update (object) {
    return Api().put('link/edit/' + object.id, object.object)
  },
  list (filter) {
    return Api().get('link/get', { params: filter })
  },
  get (id) {
    return Api().get('link/get/' + id)
  }
}